<template>
  <div class="map-with-adress">
    <div class="row">
      <div class="col-12">
        <form-dadata-autocomplete
          v-disabled-input="controllingDisableRule"
          :on-click-suggestion-callback="onClickSuggestion"
          :keymonitor="onChangeLocation"
          :error="error[addressInputName]"
          :input-model="{ name: containerState[addressInputName] }"
          :fields-to-update="[addressInputName]"
          :disable="disableInputs"
          :error-info="`${addressInputLabel}, 5-200 символов`"
          :fieldname="`${fieldname}.${addressInputName}`"
          :placeholder="addressInputLabel"
          :label="addressInputLabel"
          url-part="/suggestions/api/4_1/rs/suggest/address"
          list-view-value-field="value"
          @update="update"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form-data
          v-disabled-input="controllingDisableRule"
          :error="error.coordinates"
          :input-model="coordinatesString"
          :keymonitor="onChangeCoordinates"
          :disable="disableInputs"
          :bottom-info="!disableInputs ? 'Широта; Долгота' : ''"
          fieldname="coordinatesString"
          label="Географические координаты"
          placeholder="Географические координаты"
          error-info="Введите координаты в формате 00.000000, 00.000000"
          @update="updateData"
          @blur="onBlurCoordinates"
        />
      </div>
      <div v-if="!disableInputs" class="col-6">
        <regular-button
          v-hidden-inline-flex="controllingDisableRule"
          type="button"
          class="btn-to-location"
          :icon-before="true"
          @click="centerCoordinatesByAddress()"
        >
          <template v-slot:icon-before>
            <icon name="to-location" />
          </template>
          по адресу
        </regular-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="container-map">
          <l-map
            ref="containerMap"
            :zoom="mapConfigs.zoom"
            :center="mapCenter"
            :options="mapConfigs.options"
            @dragend="onDragMap"
            @zoom="onZoomMap($event)"
          >
            <l-tile-layer :url="mapConfigs.url" />
          </l-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import L from "leaflet";
import { LMap, LTileLayer } from "vue2-leaflet";

import Icon from "./Icon";
import RegularButton from "./RegularButton";
import FormDadataAutocomplete from "./forms/FormDadataAutocomplete";
import FormData from "./forms/FormData";

export default {
  name: "MapWithAddress",
  components: {
    LMap,
    LTileLayer,
    FormDadataAutocomplete,
    FormData,
    Icon,
    RegularButton
  },
  props: {
    controllingDisableRule: {
      type: [String, Boolean],
      default: false
    },
    error: {
      type: Object,
      default: () => ({})
    },
    containerState: {
      type: Object,
      default: () => ({})
    },
    serverError: {
      type: Boolean,
      default: false
    },
    fieldname: {
      type: [String, Array],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    errorLabel: {
      type: String,
      default: ""
    },
    errorInfo: {
      type: String,
      default: ""
    },
    mapConfigs: {
      type: Object,
      default: () => ({})
    },
    disableInputs: {
      type: Boolean,
      default: false
    },
    addressInputLabel: {
      type: String,
      default: "Фактический адрес"
    },
    addressInputName: {
      type: String,
      default: "address"
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    update: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      coordinatesString: "",
      mapCenter: L.latLng(this.mapConfigs.center)
    };
  },
  computed: {
    ...mapState(["userPermissions"])
  },
  watch: {
    "containerState.coordinates"(newValue) {
      const lat = newValue && newValue.lat ? newValue.lat : 0;
      const lng = newValue && newValue.lng ? newValue.lng : 0;
      this.$refs.containerMap.mapObject.panTo({ lng, lat });
      this.coordinatesString = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
    },
    controllingDisableRule() {
      const values = this.controllingDisableRule.split(" ").filter(code => this.userPermissions[code]);
      if (values.length === 0) {
        this.$refs.containerMap.mapObject.dragging.disable();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const lat =
        this.containerState.coordinates && this.containerState.coordinates.lat ? this.containerState.coordinates.lat : 0;
      const lng =
        this.containerState.coordinates && this.containerState.coordinates.lng ? this.containerState.coordinates.lng : 0;
      this.$refs.containerMap.mapObject.panTo({ lng, lat });
      this.coordinatesString = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;

      if (this.disableInputs) {
        this.$refs.containerMap.mapObject.dragging.disable();
      }
    });
  },
  methods: {
    ...mapActions(["getSuggestion"]),
    onDragMap(event) {
      const lat = this.containerState.coordinates.lat ? this.containerState.coordinates.lat : 0;
      const lng = this.containerState.coordinates.lng ? this.containerState.coordinates.lng : 0;

      this.update({
        fieldname: "error.coordinates",
        value: false
      });
      this.update({
        fieldname: `${this.fieldname}.coordinates`,
        value: event.target.getCenter()
      });
      this.coordinatesString = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
    },
    onZoomMap() {
      const coordinates = this.coordinatesString.split(", ");
      if (coordinates.length > 1) {
        this.$refs.containerMap.mapObject.setView({
          lat: Number(coordinates[0]),
          lng: Number(coordinates[1])
        });
      }
    },
    centerCoordinatesByAddress() {
      if (this.containerState[this.addressInputName].length > 0) {
        const params = {
          count: 1,
          query: this.containerState[this.addressInputName]
        };
        this.update({
          fieldname: "uploadData",
          value: true
        });
        this.getSuggestion(params).then(res => {
          if (res.data.suggestions && res.data.suggestions.length > 0) {
            const lat = parseFloat(res.data.suggestions[0].data.geo_lat);
            const lng = parseFloat(res.data.suggestions[0].data.geo_lon);

            this.$refs.containerMap.mapObject.panTo({ lng, lat });
            this.coordinatesString = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;

            this.update({
              fieldname: `${this.fieldname}.coordinates`,
              value: { lat: lat, lng: lng }
            });
            this.update({
              fieldname: "error.coordinates",
              value: false
            });
            this.update({
              fieldname: "uploadData",
              value: false
            });
          } else {
            this.update({
              fieldname: `error.${this.addressInputName}`,
              value: true
            });
            this.update({
              fieldname: "uploadData",
              value: false
            });
          }
        });
      }
    },
    onChangeCoordinates(e) {
      const value = e.target.value;
      const coordinates = value.split(", ");
      const regex = /^(?:(-?[1-8]?\d(?:\.\d{2,18})|90(?:\.0{2,18})?),\s(-?(?:1[0-7]|[1-9])?\d(?:\.\d{2,18})|180(?:\.0{2,18})?))(?:\|(?:(-?[1-8]?\d(?:\.\d{2,18})|90(?:\.0{2,18})?),(-?(?:1[0-7]|[1-9])?\d(?:\.\d{2,18})|180(?:\.0{2,18})?)))*$/;
      const lat = this.containerState.coordinates.lat ? this.containerState.coordinates.lat : 0;
      const lng = this.containerState.coordinates.lng ? this.containerState.coordinates.lng : 0;

      this.keymonitor();

      if (value === "") {
        this.update({
          fieldname: "error.coordinates",
          value: true
        });
        return;
      }

      if (!regex.test(value)) {
        this.update({
          fieldname: "error.coordinates",
          value: true
        });
        return;
      }

      if (!coordinates[0] || !coordinates[1]) {
        this.update({
          fieldname: `${this.fieldname}.coordinates`,
          value: {
            lat: null,
            lng: null
          }
        });
        return;
      }

      this.update({
        fieldname: "error.coordinates",
        value: false
      });

      if (e.keyCode === 13) {
        this.update({
          fieldname: `${this.fieldname}.coordinates`,
          value: {
            lat: Number(coordinates[0]),
            lng: Number(coordinates[1])
          }
        });
        // prettier-ignore
        this.coordinatesString = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
        this.$refs.containerMap.mapObject.setView({ lat, lng });
        this.keymonitor();
      }
    },
    onBlurCoordinates(e) {
      const value = e.target.value;
      const coordinates = value.split(", ");
      const regex = /^(?:(-?[1-8]?\d(?:\.\d{2,18})|90(?:\.0{2,18})?),\s(-?(?:1[0-7]|[1-9])?\d(?:\.\d{2,18})|180(?:\.0{2,18})?))(?:\|(?:(-?[1-8]?\d(?:\.\d{2,18})|90(?:\.0{2,18})?),(-?(?:1[0-7]|[1-9])?\d(?:\.\d{2,18})|180(?:\.0{2,18})?)))*$/;
      const lat = this.containerState.coordinates.lat ? this.containerState.coordinates.lat : 0;
      const lng = this.containerState.coordinates.lng ? this.containerState.coordinates.lng : 0;

      if (value === "") {
        this.update({
          fieldname: "error.coordinates",
          value: true
        });
        return;
      }

      if (!regex.test(value)) {
        this.update({
          fieldname: "error.coordinates",
          value: true
        });
        return;
      }

      if (!coordinates[0] || !coordinates[1]) {
        this.update({
          fieldname: `${this.fieldname}.coordinates`,
          value: {
            lat: null,
            lng: null
          }
        });
        return;
      }

      this.update({
        fieldname: `${this.fieldname}.coordinates`,
        value: {
          lat: Number(coordinates[0]),
          lng: Number(coordinates[1])
        }
      });

      // prettier-ignore
      this.coordinatesString = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      this.$refs.containerMap.mapObject.setView({ lat, lng });
      this.keymonitor();
    },
    onChangeLocation(e) {
      const value = e.target.value;

      if (value === "") {
        this.update({
          fieldname: `error.${this.addressInputName}`,
          value: true
        });
        return;
      }

      if (value && (value.length < 5 || value.length > 200)) {
        this.update({
          fieldname: `error.${this.addressInputName}`,
          value: true
        });
        return;
      }

      this.update({
        fieldname: `error.${this.addressInputName}`,
        value: false
      });
    },
    onClickSuggestion(suggest) {
      this.update({
        fieldname: `${this.fieldname}.${this.addressInputName}`,
        value: suggest.value
      });
      this.update({
        fieldname: `error.${this.addressInputName}`,
        value: false
      });

      const params = {
        count: 1,
        query: this.containerState[this.addressInputName]
      };

      this.update({
        fieldname: "uploadData",
        value: true
      });
      this.getSuggestion(params).then(res => {
        const lat = Number(res.data.suggestions[0].data.geo_lat);
        const lng = Number(res.data.suggestions[0].data.geo_lon);
        this.update({
          fieldname: `${this.fieldname}.coordinates`,
          value: {
            lat,
            lng
          }
        });
        this.update({
          fieldname: `${this.fieldname}.${this.addressInputName}_data`,
          value: res.data.suggestions[0].data
        });
        this.$refs.containerMap.mapObject.panTo({ lng, lat });
        this.coordinatesString = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;

        this.update({
          fieldname: "uploadData",
          value: false
        });
      });
    },
    updateData(data) {
      const target = data.fieldname.split(".");
      const dataType = typeof data.value === "undefined";

      if (target.length === 1) {
        this[target[0]] = dataType ? null : data.value;
      }
      if (target.length === 2) {
        this[target[0]][target[1]] = dataType ? null : data.value;
      }
      if (target.length === 3) {
        this[target[0]][target[1]][target[2]] = dataType ? null : data.value;
      }
    }
  }
};
</script>
